const UserLanguageLocalStorage = {
    USER_LANGUAGE: "USER_LANGUAGE",
};

export default UserLanguageLocalStorage;
